import React, { useEffect, useState } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import logo from "../assets/logo.png";
import headerBg from "../assets/cover.jpg";
import AbsensiTableClockIn from "./AbsensiTableClockIn";
import AbsensiTableClockOut from "./AbsensiTableClockOut";
import AbsensiDashboard from "./AbsensiDashboard";
import UserList from "./UserList";
import { API_BASE } from "./config";

export default function Admin() {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("clock_in");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

      fetch(`${API_BASE}/api/role`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (res.status === 401 || res.status === 403) {
          throw new Error("Token invalid/expired");
        }
        return res.json();
      })
      .then(() => setLoading(false))
      .catch(() => {
        localStorage.removeItem("token");
        navigate("/login");
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  if (loading) return <p className="p-6">Loading...</p>;

  const tabs = [
    { key: "dashboard", label: "Dashboard" },
    { key: "clock_in", label: "Clock In" },
    { key: "clock_out", label: "Clock Out" },
    { key: "user", label: "Management User" },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div
        className="relative w-full h-20 flex items-center justify-between px-6 shadow-md"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="relative z-10 flex items-center">
          <img src={logo} alt="SSD Logo" 
        onClick={() => navigate("/")}
        className="h-12 mr-3" />
        </div>
        <h1 className="absolute left-1/2 transform -translate-x-1/2 z-10 text-white font-bold text-3xl tracking-wide">
          Attendance Admin
        </h1>
        <button
          onClick={handleLogout}
          className="relative z-10 bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg text-white font-semibold shadow-lg"
        >
          Logout
        </button>
      </div>

      {/* Tabs */}
      <div className="flex justify-between items-center mb-6 border-b px-6 pt-4">
        {/* Left Tabs */}
        <div className="flex space-x-6">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`relative pb-2 text-sm font-medium transition-colors duration-200
                ${
                  activeTab === tab.key
                    ? "text-blue-600 after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-0.5 after:w-full after:bg-blue-600"
                    : "text-gray-600 hover:text-blue-500"
                }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="flex space-x-6">
          <button
            onClick={() => navigate("/admin")}
            className={`pb-2 text-sm font-medium transition-colors duration-200
              ${location.pathname === "/admin"
                ? "text-black font-semibold border-b-2 border-black cursor-default"
                : "text-blue-600 hover:text-blue-500"}`}
            disabled={location.pathname === "/admin"}
          >
            Absen
          </button>
          <button
            onClick={() => navigate("/poweradmin")}
            className={`pb-2 text-sm font-medium transition-colors duration-200
              ${location.pathname === "/poweradmin"
                ? "text-black font-semibold border-b-2 border-black cursor-default"
                : "text-blue-600 hover:text-blue-500"}`}
            disabled={location.pathname === "/poweradmin"}
          >
            Power
          </button>
        </div>
      </div>


      {/* Content */}
      <div className="px-6 pb-6">
        {activeTab === "dashboard" && <AbsensiDashboard />}
        {activeTab === "clock_in" && <AbsensiTableClockIn />}
        {activeTab === "clock_out" && <AbsensiTableClockOut />}
        {activeTab === "user" && <UserList />}
      </div>
    </div>
  );
}
